import React from "react";
import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useReceivableModel } from "../receivableModel";
import useNavModel from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { formatNum } from "@/utils/utils";
export const DataBox = () => {
    const { loadData, descTotal, selectedRowKeys, rowsDescTotal, receivableExcel } = useReceivableModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        receivableExcel()
    }
    const title = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={onEdit}
    >{Locale["export"]}</Button>
    const desc: IDescription[] = [
        {
            // label: "应收金额",
            label: Locale["Receivable Amounts"],
            value: selectedRowKeys.length === 0 ? descTotal.receivableAmount : formatNum(rowsDescTotal.receivableAmount),
            color: DescriptionColorEnum.red
        }
    ]
    return (
        <YhBox title={title} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}